export enum EnvVar {
  ADVISOR_API = "ADVISOR_API",
  ADVISOR_PREVIEW_API = "ADVISOR_PREVIEW_API",
  SENTRY_ENABLED = "SENTRY_ENABLED",
  SENTRY_DSN = "SENTRY_DSN",
  SENTRY_SAMPLE_RATE = "SENTRY_SAMPLE_RATE",
  SENTRY_ENVIRONMENT = "SENTRY_ENVIRONMENT",
  SENTRY_SERVICE = "SENTRY_SERVICE",
}

type Config = Record<EnvVar, string | undefined>

declare global {
  interface Window {
    _env_: Config
  }
}

export const envVar = (key: EnvVar): string | boolean | undefined => {
  if (!window._env_) return

  const val = window._env_[key]
  switch (val) {
    case "true":
      return true
    case "false":
      return false
    default:
      return val
  }
}
